import type { EditorProps } from '@atlaskit/editor-core';
import { fg } from '@atlaskit/platform-feature-flags';

export const useValidTransactionTrackingOptions = (): EditorProps['trackValidTransactions'] => {
	if (fg('fabric_editor_valid_transactions_tracking')) {
		return {
			samplingRate: 300,
		};
	}
};
